export default __webpack_public_path__ + "static/media/petfinder.b481b112.jpg";